export default __webpack_public_path__ + "static/media/29.3d5eff21.png";